/* Portwest PDP enhancements: delivery estimates and product-derived standards. */
(function () {
  'use strict';

  function londonToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
  }

  function addWorkingDays(startDate, numberOfDays) {
    var date = new Date(startDate.getTime());
    var daysAdded = 0;

    while (daysAdded < numberOfDays) {
      date.setUTCDate(date.getUTCDate() + 1);
      var day = date.getUTCDay();
      if (day !== 0 && day !== 6) daysAdded += 1;
    }

    return date;
  }

  function formatUkDate(date) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(date);
  }

  function getDescription(section) {
    var json = section.querySelector('script.product-json');
    if (!json) return '';

    try {
      return JSON.parse(json.textContent || '{}').description || '';
    } catch (error) {
      return '';
    }
  }

  function normaliseText(html) {
    var container = document.createElement('div');
    container.innerHTML = html;
    return (container.textContent || container.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }

  function standardsFromDescription(description) {
    var text = normaliseText(description);
    var standards = [];
    var patterns = [
      /\bEN(?:\s+ISO)?\s+\d{3,6}(?::\d{2,4})?(?:\s*\([^)]{1,36}\))?(?:\s+(?:Class|Type|Level|Index)\s*[A-Z0-9]+)?/gi,
      /\bIEC\s+\d{3,6}(?:-\d+)?(?::\d{2,4})?/gi,
      /\bASTM\s+[A-Z]?\d{3,5}(?:-\d{2})?/gi,
      /\bANSI(?:\s+[A-Z]+)?\s+(?:[A-Z]?\d+|[A-Z]+\d+)/gi,
      /\bRIS[-\s]?\d{3,5}(?:[-\s]?[A-Z]+)?/gi
    ];

    patterns.forEach(function (pattern) {
      var matches = text.match(pattern) || [];
      standards = standards.concat(matches.map(function (item) { return item.trim(); }));
    });

    if (/\bCE certified\b/i.test(text)) standards.push('CE certified');
    if (/\bUKCA marked\b/i.test(text)) standards.push('UKCA marked');
    if (/\bflame resistant\b|\bflame retardant\b/i.test(text)) standards.unshift('Flame resistant');
    if (/\barc[\s-]?(?:rated|flash)\b/i.test(text)) standards.unshift('Arc flash protection');
    if (/\bcut resistant\b|\bcut resistance\b/i.test(text)) standards.unshift('Cut resistance');
    if (/\bhigh visibility\b|\bhi-vis\b/i.test(text)) standards.unshift('High-visibility workwear');
    if (/\bwaterproof\b/i.test(text)) standards.unshift('Waterproof protection');

    return unique(standards).slice(0, 6);
  }

  function initialiseSection(section) {
    if (!section || section.dataset.twwPortwestInitialised === 'true') return;
    if (section.dataset.twwPortwestProduct !== 'true') return;

    section.dataset.twwPortwestInitialised = 'true';

    var delivery = section.querySelector('[data-tww-portwest-delivery]');
    if (delivery) {
      var today = londonToday();
      delivery.querySelectorAll('[data-tww-portwest-eta]').forEach(function (time) {
        var days = Number(time.dataset.twwPortwestEta);
        var eta = addWorkingDays(today, days);
        time.dateTime = eta.toISOString().slice(0, 10);
        time.textContent = formatUkDate(eta);
      });
    }

    var protection = section.querySelector('[data-tww-portwest-protection]');
    if (protection) {
      var standards = standardsFromDescription(getDescription(section));
      var list = protection.querySelector('[data-tww-portwest-protection-list]');
      var fallback = protection.querySelector('[data-tww-portwest-protection-fallback]');

      if (standards.length && list) {
        list.innerHTML = standards.map(function (standard) {
          return '<li>' + standard.replace(/[&<>"']/g, function (character) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
          }) + '</li>';
        }).join('');
        list.hidden = false;
        if (fallback) fallback.hidden = true;
      }
    }
  }

  function initialiseAll() {
    document.querySelectorAll('[data-section-type="product__section"][data-tww-portwest-product="true"]').forEach(initialiseSection);
  }

  function watchForProductRefreshes() {
    var observer = new MutationObserver(function () {
      initialiseAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll();
      watchForProductRefreshes();
    });
  } else {
    initialiseAll();
    watchForProductRefreshes();
  }
}());
